<template>
  <div>
    <NoticesIndividualSubShutdownDialog v-if="activeNoticeId === 'individualSubShutdown'" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"

import { useNoticesStore } from "~/stores/noticesStore"
import { useUserStore } from "~/stores/userStore"

const NOTICE_PRIORITY = ["individualSubShutdown"] as const
type NoticeId = (typeof NOTICE_PRIORITY)[number]

export default defineComponent({
  setup() {
    const userStore = useUserStore()
    const noticesStore = useNoticesStore()
    return { userStore, noticesStore }
  },

  computed: {
    activeNoticeId(): NoticeId | null {
      const user = this.userStore.current
      if (!user) {
        return null
      }
      const dismissed = this.noticesStore.notices
      const skipped = this.noticesStore.sessionSkipped
      for (const id of NOTICE_PRIORITY) {
        if (dismissed[id]?.dismissedAt) {
          continue
        }
        if (skipped.includes(id)) {
          continue
        }
        if (id === "individualSubShutdown" && user.has_individual_subscription) {
          return id
        }
      }
      return null
    },
  },
})
</script>
